'use strict'
import serviceBase from './serviceBase'
const guestEmailService = {
    SendMailToSuite:(data)=>serviceBase.post('/guestEmails/sendMailToSuite',data),
    GuestServiceRequestEmail:(data)=>serviceBase.post('/guestEmails/serviceRequestEmail',data),
   }
export default guestEmailService